export const fonts = {
  body: 'Helvetica Neue, system-ui, sans-serif',
  heading: 'Gilroy, system-ui, sans-serif',
  mono: 'Helvetica Neue, system-ui, sans-serif',
};

export const fontWeights = {
  normal: 500,
  medium: 600,
  bold: 700,
};

export const fontSizes = {
  xs: '0.75rem',
  sm: '0.875rem',
  md: '1rem',
  base: '1rem',
  lg: '1.125rem',
  '3xl': '1.875rem',
  '4xl': '2.25rem',
  '5xl': '3rem',
};

export const lineHeights = {
  xs: '0.75rem',
  sm: '0.875rem',
  md: '1rem',
  lg: '1.125rem',
  xl: '1.25rem',
  '2xl': '1.5rem',
  '3xl': '1.875rem',
  '4xl': '2.25rem',
  '5xl': '3rem',
  '6xl': '4rem',
};
